import React, { lazy, Suspense } from 'react'
import ScrollToTop from "./ScrollToTop";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./Layout";
import Home from "../pages/home/Home";
import { useModal } from "../contexts/ModalContext";

const loadPage = (clientLoader, serverPath) => {
  if (typeof window === "undefined") {
    const serverRequire = module.require.bind(module);
    const loadedModule = serverRequire(serverPath);
    return loadedModule.default || loadedModule;
  }

  return lazy(clientLoader);
};

const ThankYou = loadPage(() => import("../pages/thankYou/ThankYou"), "../pages/thankYou/ThankYou");
const BlogListing = loadPage(() => import("../pages/blogListing/BlogListing"), "../pages/blogListing/BlogListing");
const BlogDetail = loadPage(() => import("../pages/blogDetail/BlogDetail"), "../pages/blogDetail/BlogDetail");
const ContactUs = loadPage(() => import("../pages/contactUs/ContactUs"), "../pages/contactUs/ContactUs");
const ProjectListing = loadPage(() => import('../pages/ProjectListing/ProjectListing'), '../pages/ProjectListing/ProjectListing');
const LandingPage = loadPage(() => import("../pages/LandingPage/Home"), "../pages/LandingPage/Home");
const ProjectDetail = loadPage(() => import('../pages/ProjectDetail/ProjectDetail'), '../pages/ProjectDetail/ProjectDetail');
const ServiceListing = loadPage(() => import('../pages/ServiceListing/ServiceListing'), '../pages/ServiceListing/ServiceListing');
const Error = loadPage(() => import('../pages/404/Error'), '../pages/404/Error');
const InteriorDesign = loadPage(() => import('../pages/InteriorDesign/InteriorDesign'), '../pages/InteriorDesign/InteriorDesign');
const TermsCondition = loadPage(() => import('../pages/TermsCondition/TermsCondition'), '../pages/TermsCondition/TermsCondition');
const Partner = loadPage(() => import('../pages/Partner/Partner'), '../pages/Partner/Partner');
const TurnkeyExecution = loadPage(() => import('../pages/TurnkeyExecution/TurnkeyExecution'), '../pages/TurnkeyExecution/TurnkeyExecution');
const About = loadPage(() => import('../pages/About/About'), '../pages/About/About');
const CareerDetail = loadPage(() => import('../pages/careerDetail/CareerDetail'), '../pages/careerDetail/CareerDetail');
const PropertyManagement = loadPage(() => import('../pages/PropertyManagement/PropertyManagement'), '../pages/PropertyManagement/PropertyManagement');
const CareerForm = loadPage(() => import('../pages/careerForm/CareerForm'), '../pages/careerForm/CareerForm');
const CareerListing = loadPage(() => import('../pages/careerListing/CareerListing'), '../pages/careerListing/CareerListing');
const Client = loadPage(() => import('../pages/Client/Client'), '../pages/Client/Client');
const PrivacyPolicy = loadPage(() => import('../pages/PrivacyPolicy/PrivacyPolicy'), '../pages/PrivacyPolicy/PrivacyPolicy');
const DynamicPage = loadPage(() => import('../pages/DynamicPage/DynamicPage'), '../pages/DynamicPage/DynamicPage');
const Referral = loadPage(() => import('../pages/Referral/Referral'), '../pages/Referral/Referral');
const DynamicListing = loadPage(() => import('../pages/DynamicListing/DynamicListing'), '../pages/DynamicListing/DynamicListing');
const Testimonial = loadPage(() => import('../pages/Testimonial/Testimonial'), '../pages/Testimonial/Testimonial');
const EnquiryPopup = loadPage(() => import('../components/EnquiryPopup'), '../components/EnquiryPopup');
const ResidentialInterior = loadPage(() => import('../pages/ResidentialInterior/ResidentialInterior'), '../pages/ResidentialInterior/ResidentialInterior');
const InteriordesigningCompany = loadPage(() => import('../pages/InteriordesigningCompany/InteriordesigningCompany'), '../pages/InteriordesigningCompany/InteriordesigningCompany');
const InteriordesignerGurgaon = loadPage(() => import('../pages/InteriordesignerGurgaon/InteriordesignerGurgaon'), '../pages/InteriordesignerGurgaon/InteriordesignerGurgaon');
const OfficeInterior = loadPage(() => import('../pages/OfficeInterior/OfficeInterior'), '../pages/OfficeInterior/OfficeInterior');
const InteriorDecorator = loadPage(() => import('../pages/InteriorDecorator/InteriorDecorator'), '../pages/InteriorDecorator/InteriorDecorator');

function Redirect({ to }) {
  if (typeof window !== "undefined") {
    return <Navigate to={to} replace />;
  }
  return null;
}

export default function NavRouter({ initialData }) {
  const { modalShow, closeQueryModal } = useModal();
  
  return (
    <>
      <ScrollToTop />
      {modalShow && (
        <Suspense fallback={null}>
          <EnquiryPopup show={modalShow} setShow={closeQueryModal}/>
        </Suspense>
      )}
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home initialData={initialData}/>} />
            <Route path="blog/" element={<BlogListing initialData={initialData}/>} />
            <Route path="blog/:slug" element={<BlogDetail initialData={initialData} />} />
            <Route path="contact-us/" element={<ContactUs />} />
            <Route path="disclaimer/" element={<TermsCondition />} />
            <Route path="privacy-policy/" element={<PrivacyPolicy />} />
            <Route path="partner-with-us/" element={<Partner initialData={initialData}/>} />
            <Route path="our-story/" element={<About />} />

            {/* career */}
            <Route path="career-form" element={<CareerForm />} />
            <Route path="careers/" element={<CareerListing initialData={initialData}/>} />
            <Route path="career/:career_slug" element={<CareerDetail initialData={initialData}/>} />
        
            <Route path="luxury-interior-designer-gurgaon/" element={<LandingPage/>} />
            <Route path="projects/" element={<ProjectListing initialData={initialData}/>} />
            <Route path="projects/:project_slug" element={<ProjectDetail initialData={initialData}/>} />
            <Route path="services/" element={<ServiceListing/>} />
            <Route path="interior-design-build/" element={<InteriorDesign initialData={initialData}/>} />
            <Route path="turnkey-interior-design-services/" element={<TurnkeyExecution initialData={initialData}/>} />
            <Route path="top-property-management-services/" element={<PropertyManagement initialData={initialData}/>} />
            <Route path="our-clients/" element={<Client initialData={initialData}/>} />
            <Route path="from-the-archive/" element={<DynamicListing initialData={initialData}/>} />
            <Route path="/:slug" element={<DynamicPage initialData={initialData}/>} />
            <Route path="pms-referral/" element={<Referral/>} />
            <Route path="testimonial/" element={<Testimonial initialData={initialData}/>} />


            <Route path="residential-interior-designers-in-gurgaon/" element={<ResidentialInterior initialData={initialData}/>} />
            <Route path="interior-designing-company/" element={<InteriordesigningCompany initialData={initialData}/>} />
            <Route path="interior-designers-in-gurgaon/" element={<InteriordesignerGurgaon initialData={initialData}/>} />
            <Route path="office-interior-designer-in-gurgaon/" element={<OfficeInterior initialData={initialData}/>} />
            <Route path="interior-decorator-in-gurgaon/" element={<InteriorDecorator initialData={initialData}/>} />

            {/* Routes without footer*/}
            <Route path="thank-you" element={<ThankYou />} />
            <Route path="/404" element={<Error />} />
            <Route path="*" element={<Redirect to="/404" />} />
          </Route>
        
        </Routes>
      </Suspense>
    </>
  )
}
